import Vue from "vue";
import Vuex from "vuex";
import api from "@/fetch/api";

import { getCookies } from "@/utils/utils";
import { getStore } from "@/utils/utils";

Vue.use(Vuex);

const state = {
  token: getCookies("token") || "",
  userInfo:
    (getCookies("adminInfo") && JSON.parse(getCookies("adminInfo"))) || {},
  enums: {},
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_ENUMS: (state, enums) => {
    state.enums = enums;
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo;
  }
};
const actions = {
  setToken({ commit }, token) {
    commit("SET_TOKEN", token);
  },
  setUserInfo({ commit }, userInfo) {
    commit("SET_USERINFO", userInfo);
  },
  getEnumsList({ commit, state }){
    return new Promise((resolve, reject) => {
      api.getEnumsList().then(response => {
        if (response.code !== 200) {
          return reject('请求失败，请联系开发人员')
        }
        commit('SET_ENUMS', response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
};

export default new Vuex.Store({
  state,
  actions,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js